/**
 * Day/night theme toggle (pairs with snippets/buzzlove-theme-toggle.liquid).
 *
 * The boot script in theme.liquid already resolved html[data-theme] before
 * paint; this file only flips it on click and keeps the buttons' ARIA state
 * honest. The click handler is delegated so buttons survive Horizon's
 * section-hydration morphs, and syncState() re-runs after any header DOM
 * replacement for the same reason.
 */
(function () {
  var KEY = 'bl-theme';

  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function syncState() {
    var dark = currentTheme() === 'dark';
    var label = dark ? 'Switch to day theme' : 'Switch to night theme';
    document.querySelectorAll('.bl-theme-toggle').forEach(function (button) {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', label);
      button.title = label;
    });
  }

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch (error) {
      /* storage blocked — the flip still applies for this page */
    }
    syncState();
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('.bl-theme-toggle');
    if (!button) return;
    setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  var header = document.querySelector('header-component');
  if (header) {
    new MutationObserver(syncState).observe(header, { childList: true, subtree: true });
  }

  syncState();
})();
